import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ll-steps" }
const _hoisted_2 = { class: "ll-step ll-now" }
const _hoisted_3 = { class: "ll-time" }
const _hoisted_4 = { class: "ll-step" }
const _hoisted_5 = { class: "ll-step" }
const _hoisted_6 = { class: "ll-ghost mt-5" }
const _hoisted_7 = {
  class: "ll-ghost-content",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "ll-ghost-head" }
const _hoisted_9 = { class: "ll-ghost-title" }
const _hoisted_10 = { class: "ll-ghost-pill" }
const _hoisted_11 = { class: "ll-ghost-grid" }
const _hoisted_12 = { class: "ll-bars" }
const _hoisted_13 = ["data-peak"]
const _hoisted_14 = { class: "ll-rows" }
const _hoisted_15 = { class: "ll-row" }
const _hoisted_16 = { class: "ll-tag ll-tag-teal" }
const _hoisted_17 = { class: "ll-row" }
const _hoisted_18 = { class: "ll-tag ll-tag-amber" }
const _hoisted_19 = { class: "ll-row" }
const _hoisted_20 = { class: "ll-tag ll-tag-teal" }
const _hoisted_21 = { class: "ll-lock" }
const _hoisted_22 = { class: "ll-lock-ic" }
const _hoisted_23 = { class: "ll-micro-trust" }

import { useI18n } from 'vue-i18n';
import { LockClosedIcon } from '@heroicons/vue/24/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectEmpty',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ll-n" }, "1", -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.arrival.steps.s1')) + " ", 1),
        _createElementVNode("span", _hoisted_3, "· " + _toDisplayString(_unref(t)('livvia.arrival.steps.s1time')), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "ll-arrow",
        "aria-hidden": "true"
      }, "→", -1)),
      _createElementVNode("span", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ll-n" }, "2", -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.arrival.steps.s2')), 1)
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "ll-arrow",
        "aria-hidden": "true"
      }, "→", -1)),
      _createElementVNode("span", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ll-n" }, "3", -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.arrival.steps.s3')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('livvia.arrival.ghost.title')), 1),
          _createElementVNode("span", _hoisted_10, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ll-ghost-dot" }, null, -1)),
            _createTextVNode(_toDisplayString(_unref(t)('livvia.arrival.ghost.pill')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[6] || (_cache[6] = _createElementVNode("i", { style: {"height":"30%"} }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("i", { style: {"height":"48%"} }, null, -1)),
            _cache[8] || (_cache[8] = _createElementVNode("i", { style: {"height":"38%"} }, null, -1)),
            _cache[9] || (_cache[9] = _createElementVNode("i", { style: {"height":"62%"} }, null, -1)),
            _createElementVNode("i", {
              class: "ll-pk",
              "data-peak": _unref(t)('livvia.arrival.ghost.peak'),
              style: {"height":"100%"}
            }, null, 8, _hoisted_13),
            _cache[10] || (_cache[10] = _createStaticVNode("<i style=\"height:70%;\" data-v-2b4031b7></i><i style=\"height:44%;\" data-v-2b4031b7></i><i style=\"height:56%;\" data-v-2b4031b7></i><i style=\"height:32%;\" data-v-2b4031b7></i><i style=\"height:24%;\" data-v-2b4031b7></i>", 5))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, [
                _cache[11] || (_cache[11] = _createElementVNode("b", null, "carla.brecho", -1)),
                _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.report.m1')), 1)
              ]),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('home.landing.spots.report.tagOrder')), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, [
                _cache[12] || (_cache[12] = _createElementVNode("b", null, "ju_semijoias", -1)),
                _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.report.m2')), 1)
              ]),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('home.landing.spots.report.tagDoubt')), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, [
                _cache[13] || (_cache[13] = _createElementVNode("b", null, "maria.moda", -1)),
                _createTextVNode(" · " + _toDisplayString(_unref(t)('home.landing.spots.report.m3')), 1)
              ]),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('home.landing.spots.report.tagOrder')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_unref(LockClosedIcon), {
            class: "size-5 text-gray-500",
            "aria-hidden": "true"
          })
        ]),
        _createElementVNode("b", null, _toDisplayString(_unref(t)('livvia.arrival.ghost.lockTitle')), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(t)('livvia.arrival.ghost.lockSub')), 1)
      ])
    ]),
    _createElementVNode("p", _hoisted_23, [
      _createElementVNode("b", null, _toDisplayString(_unref(t)('livvia.arrival.trustCount')), 1),
      _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.arrival.trustRest')), 1)
    ])
  ]))
}
}

})